import { AppNavbar } from '@/components/layout/AppNavbar';
import { GSDocumentToolNavbar } from '@/components/layout/GSDocumentToolNavbar';
import { usePersonaContext } from '@/contexts/PersonaContext';

// Utility hook to determine which header component to render
export const usePersonaHeader = () => {
  const { currentPersona } = usePersonaContext();
  
  const shouldUseGSHeader = 
    currentPersona?.name === 'GS Cert Platform - Client' ||
    currentPersona?.name === 'GS Document Tool User';
  
  return shouldUseGSHeader ? GSDocumentToolNavbar : AppNavbar;
};

// Utility hook to get the base path for routing depending on persona
export const usePersonaBasePath = () => {
  const { currentPersona } = usePersonaContext();
  const gsPersonaNames = ['GS Cert Platform - Client', 'GS Document Tool User'];
  return gsPersonaNames.includes(currentPersona?.name || '') ? '/gs-cert-client' : '/client';
};

// Component that renders the appropriate header based on persona
export const PersonaAwareHeader = () => {
  const HeaderComponent = usePersonaHeader();
  return <HeaderComponent />;
};